<template>
  <div>
    <b-container fluid id="leadInfoContainer">
      <b-row>
        <b-col cols="4">中文姓名</b-col>
        <b-col cols="8">
          {{ leadInfo.ChineseName }}
          <a href="javascript:void(0)" v-if="EditPermission" @click="edit">
            <img
              src="../../../static/img/icons8-edit-32.png"
              width="20px"
              height="20px"
              title="edit"
            />
          </a>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">英文姓名</b-col>
        <b-col cols="8">{{ leadInfo.EnglishName }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">行動電話</b-col>
        <b-col cols="8">{{ leadInfo.PhoneNumber }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">E - mail</b-col>
        <b-col cols="8">{{ leadInfo.Email }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">名單狀態</b-col>
        <b-col cols="8">{{ leadInfo.StatusDesc }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">主聯業務</b-col>
        <b-col cols="8">{{ leadInfo.MainContactName }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">成交業務</b-col>
        <b-col cols="8">{{ leadInfo.DealSalesName }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">註冊狀態</b-col>
        <b-col cols="3">{{ leadInfo.RegistStatus }}</b-col>
        <b-col cols="5" style="text-align: center !important">
          <b-button
            variant="danger"
            v-if="showRegisteredButton()"
            @click="signUp()"
            class="btn"
            >一鍵註冊</b-button
          >
        </b-col>
      </b-row>
    </b-container>
    <b-container id="bindStates">
      <b-card
        no-body
        header-bg-variant="danger"
        header-text-variant="white"
        header="SCRM綁定狀態"
      >
        <b-list-group flush>
          <b-list-group-item v-for="(Provider, index) in leadInfo.Providers" :key="index">
            <b-container>
              <b-row>
                <b-col cols="6">{{ Provider.ProviderName }}</b-col>
                <b-col cols="3" style="text-align: right">{{
                  showBindInfo(Provider)
                }}</b-col>
                <b-col cols="3">
                  <b-button
                    v-if="showInvitationPageButton(Provider)"
                    variant="danger"
                    @click="openMobileInvitationPageView(Provider)"
                    class="btn"
                    >綁定</b-button
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-container>
    <div style="text-align: center; padding-top: 10px">
      <b-button variant="danger" @click="goToTackingLead()" style="float: none"
        >後續追蹤</b-button
      >
    </div>
  </div>
</template>

<script>
import { LeadHandler } from "@/handler/LeadHandler.js";
import { Loading } from "element-ui";
import { TutorChatTokenHandler } from "@/handler/TutorChatTokenHandler.js";
import http from "../../http.js";
import qs from "qs";
export default {
  props: ["leadSn"],
  data() {
    return {
      EditPermission: false,
      staff: [],
      tutorChatToken: "",
      leadInfo: {
        LeadSn: "",
        ClientSn: "",
        ChineseName: "",
        EnglishName: "",
        PhoneNumber: "",
        Email: "",
        Status: "",
        StatusDesc: "",
        MainContactSn: "",
        MainContactName: "",
        DealSalesStaffSn: "",
        DealSalesName: "",
        RegistStatus: "",
        IsMainContact: "",
        Providers: [
          {
            ProviderId: "",
            ProviderName: "",
            SocialNetworkId: "",
            SocialNetwork: "",
            SocialNetworkName: "",
            Channel: "",
            ChannelId: "",
            IsBind: "",
            Invitation: [
              {
                Code: "",
                ExpireTime: "",
                InviterId: "",
                InviteTime: "",
                LeadSn: "",
                ErrorMessage: "",
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    var that = this;
    that.staff = that.GetLoginStaff();

    var ticket = this.GetTicket();
    that.tutorChatToken = TutorChatTokenHandler.getTctToken(ticket);

    that.leadInfo = LeadHandler.GetLead(that.leadSn, that.staff.staffid);

    http
      .post(
        "Lead/QueryLeadProfilePermission",
        qs.stringify({
          leadSn: that.leadSn,
          staffId: that.staff.staffid,
        })
      )
      .then(function (response) {
        var data = response.data;
        that.EditPermission = data.Result;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    edit() {
      window.location.href =
        "#/MobilePotentialClientProfileView?ls=" + this.leadSn;
    },
    openMobileInvitationPageView: function (Provider) {
      if (Provider.IsBind) {
        return;
      }
      if (!this.leadInfo.IsMainContact) {
        alert("您不是此名單的主聯業務。");
      }
      if (!Provider.IsBind && this.leadInfo.IsMainContact) {
        window.location.href =
          "#/MobileInvitationPageView?pid=" +
          Provider.ProviderId +
          "&ls=" +
          this.leadSn +
          "&tct=" +
          this.tutorChatToken;
      }
    },
    showBindInfo: function (Provider) {
      if (Provider.IsBind) {
        return "已綁定";
      } else {
        if (Provider.Invitation != undefined) {
          return Provider.Invitation.Code;
        }
        return "未綁定";
      }
    },
    showInvitationPageButton: function (Provider) {
      if (Provider.IsBind) {
        return false;
      } else {
        return true;
      }
    },
    showRegisteredButton: function () {
      if (
        this.leadInfo.RegistStatus == "未註冊" &&
        this.leadInfo.IsMainContact
      ) {
        return true;
      } else {
        return false;
      }
    },
    signUp: function () {
      let loadingInstance = Loading.service({ fullscreen: true });
      var signUpResult = LeadHandler.signUp(
        this.leadInfo.LeadSn,
        this.tutorChatToken
      );
      loadingInstance.close();
      if (signUpResult) {
        alert("註冊成功");
      } else {
        alert("註冊失敗，請聯絡技術單位。");
      }
      window.location.reload();
    },
    goToTackingLead: function () {
      var tackingLeadURL =
        "#/MobileTackingLeadView?ls=" +
        this.leadSn +
        "&tct=" +
        this.tutorChatToken +
        "&sli=";
      window.location.href = tackingLeadURL;
    },
  },
};
</script>

<style scoped>
#leadInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 10px 15px;
}
#leadInfoContainer .row {
  height: 12.5%;
}

#leadInfoContainer > div > div:first-child {
  color: #aaa;
  font-weight: bold;
  position: relative;
}

#leadInfoContainer > div > div:first-child:after {
  content: "／";
  font-weight: normal;
  color: #ddd;
  position: absolute;
  left: 80px;
  top: 0;
}

#leadInfoContainer .row div {
  line-height: 40px;
}
#leadInfoContainer .row .col-8 {
  padding-left: 0px;
}
#leadInfoContainer .row .col-3 {
  padding-left: 0px;
}
#leadInfoContainer {
  height: 60%;
  max-width: 1140px;
}
#bindStates {
  height: 40%;
  padding: 0;
}

.btn {
  float: right;
  font-size: 13px;
  background: #b20404;
}

.card {
  font-size: 13px;
  margin-top: 15px;
}

.card-header {
  background: #989898 !important;
  padding: 10px 15px;
}

.list-group-item {
  padding: 10px 15px;
}

.list-group-item .col-6,
.list-group-item .col-3 {
  padding: 0px;
}

.list-group-item .col-6 {
  color: #999;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.list-group-item .col-3 {
  text-align: right;
}

.list-group-item .row div:first-child,
.list-group-item .row div:nth-child(2) {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/LeadInfo.vue